import React from "react"
import Header from "./Header"
import Footer from "./Footer"

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            {/* Header - Fixed across all pages */}
            <Header />

            {/* Main Content - Flexible area for page content */}
            <main className="flex-grow">
                {children}
            </main>

            {/* Footer - Fixed across all pages */}
            <Footer />
        </div>
    )
}
